'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    carouselClassNames: function() {
        return carouselClassNames;
    },
    useCarouselStyles_unstable: function() {
        return useCarouselStyles_unstable;
    }
});
const _react = require("@griffel/react");
const carouselClassNames = {
    root: 'fui-Carousel'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        B68tc82: "f1p9o1ba",
        Eiaeu8: "f1115ve7",
        qhf8xq: "f10pi13n"
    }
}, {
    d: [
        ".f1p9o1ba{overflow-x:hidden;}",
        ".f1115ve7{overflow-anchor:none;}",
        ".f10pi13n{position:relative;}"
    ]
});
const useCarouselStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(carouselClassNames.root, styles.root, state.root.className);
    return state;
};
